import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const WALLS = ['wp-01-navy-mint','wp-02-navy-solid','wp-03-black-outline','wp-04-light','wp-05-mint-deep','wp-06-indigo',
  'wp-07-lockup-links','wp-08-rechts-groot','wp-09-cluster-rechts','wp-10-split','wp-11-diagonaal','wp-12-licht-rechts',
  'wp-13-zwart-vertikaal','wp-14-indigo-stack','wp-15-rustig-hoek','wp-16-mint-solid'];
const LS_LOCK='womsys_locked', LS_WALL='womsys_lock_wall', LS_IDLE='womsys_lock_idle_min';
const pick = () => { const v = localStorage.getItem(LS_WALL); return v && WALLS.includes(v) ? v : WALLS[Math.floor(Math.random()*WALLS.length)]; };

export default function LockScreen() {
  const { gebruiker, logout } = useAuth();
  const [locked, setLocked] = useState(() => localStorage.getItem(LS_LOCK) === '1');
  const [wall, setWall] = useState(pick);
  const [fixed, setFixed] = useState(() => !!localStorage.getItem(LS_WALL));
  const [pw, setPw] = useState(''); const [err, setErr] = useState(''); const [busy, setBusy] = useState(false);
  const inputRef = useRef(null); const idleRef = useRef(null);

  const lock = useCallback(() => { localStorage.setItem(LS_LOCK,'1'); setWall(pick()); setPw(''); setErr(''); setLocked(true); }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.ctrlKey && e.shiftKey && (e.key === 'L' || e.key === 'l')) { e.preventDefault(); lock(); } };
    window.addEventListener('keydown', onKey); return () => window.removeEventListener('keydown', onKey);
  }, [lock]);

  useEffect(() => {
    const min = parseInt(localStorage.getItem(LS_IDLE) ?? '15', 10);
    if (!min || locked) return;
    const reset = () => { clearTimeout(idleRef.current); idleRef.current = setTimeout(lock, min*60000); };
    ['mousemove','keydown','click','scroll','touchstart'].forEach(ev => window.addEventListener(ev, reset, {passive:true}));
    reset();
    return () => { clearTimeout(idleRef.current); ['mousemove','keydown','click','scroll','touchstart'].forEach(ev => window.removeEventListener(ev, reset)); };
  }, [locked, lock]);

  useEffect(() => { if (locked) setTimeout(() => inputRef.current?.focus(), 50); }, [locked]);

  const unlock = async (e) => {
    e?.preventDefault(); if (!pw || busy) return; setBusy(true); setErr('');
    try { await api.post('/auth/verify-password', { wachtwoord: pw }); localStorage.removeItem(LS_LOCK); setLocked(false); setPw(''); }
    catch (ex) { setErr(ex?.response?.data?.message || 'Onjuist wachtwoord'); setPw(''); inputRef.current?.focus(); }
    finally { setBusy(false); }
  };
  const step = (d) => { const i = (WALLS.indexOf(wall)+d+WALLS.length)%WALLS.length; setWall(WALLS[i]); if (fixed) localStorage.setItem(LS_WALL, WALLS[i]); };
  const toggleFixed = () => { if (fixed) { localStorage.removeItem(LS_WALL); setFixed(false); } else { localStorage.setItem(LS_WALL, wall); setFixed(true); } };

  if (!locked) return null;
  const naam = gebruiker?.voornaam || gebruiker?.naam || gebruiker?.gebruikersnaam || '';
  return (
    <div style={{position:'fixed',inset:0,zIndex:2147483647,backgroundImage:`url(/img/lock/${wall}.png)`,backgroundSize:'cover',backgroundPosition:'center',display:'flex',alignItems:'flex-end',justifyContent:'center',padding:'6vh'}}>
      <form onSubmit={unlock} style={{background:'rgba(10,18,32,0.72)',backdropFilter:'blur(14px)',WebkitBackdropFilter:'blur(14px)',border:'1px solid rgba(0,212,168,0.35)',borderRadius:16,padding:'28px 32px',width:380,color:'#fff',fontFamily:'system-ui,sans-serif',boxShadow:'0 20px 60px rgba(0,0,0,0.5)'}}>
        <div style={{fontSize:13,opacity:0.7,letterSpacing:2,textTransform:'uppercase'}}>Vergrendeld</div>
        <div style={{fontSize:22,fontWeight:700,margin:'4px 0 18px'}}>{naam}</div>
        <input ref={inputRef} type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="Wachtwoord" autoComplete="current-password"
          style={{width:'100%',boxSizing:'border-box',padding:'12px 14px',borderRadius:10,border:'1px solid rgba(255,255,255,0.2)',background:'rgba(255,255,255,0.08)',color:'#fff',fontSize:16,outline:'none'}}/>
        {err && <div style={{color:'#ff7b7b',fontSize:13,marginTop:8}}>{err}</div>}
        <button type="submit" disabled={busy||!pw} style={{width:'100%',marginTop:14,padding:'12px',borderRadius:10,border:'none',background:'#00D4A8',color:'#0B1220',fontWeight:700,fontSize:15,cursor:'pointer',opacity:busy||!pw?0.6:1}}>{busy?'…':'Ontgrendelen'}</button>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:16,fontSize:12,opacity:0.75}}>
          <span><button type="button" onClick={()=>step(-1)} style={btn}>◀</button> <button type="button" onClick={toggleFixed} style={btn} title="Deze achtergrond vast zetten">{fixed?'📌 vast':'🔀 random'}</button> <button type="button" onClick={()=>step(1)} style={btn}>▶</button></span>
          <button type="button" onClick={()=>{localStorage.removeItem(LS_LOCK); logout();}} style={btn}>Uitloggen</button>
        </div>
        <div style={{fontSize:11,opacity:0.45,marginTop:10}}>Ctrl+Shift+L vergrendelt</div>
      </form>
    </div>
  );
}
const btn={background:'transparent',border:'none',color:'#fff',cursor:'pointer',fontSize:12,padding:'2px 4px',opacity:0.9};
